import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

import { ApiClient } from '../api.client';
import { Customer } from '../../models/customer';
import { CustomerSalesHistoryItem } from '../../customers/view/sales-history/sales-history.component';
import { CustomerPreviousHiresItem } from 'src/app/customers/view/previously-hired-items/previous-hires-datasource';
@Injectable()
export class CustomerService {
  constructor(private http: ApiClient) {}

  public getCustomers(): Observable<Customer[]> {
    return this.http.get<Array<Customer>>(`customers?excludeDeleted=1`).pipe(
      map((response) => {
        const customers = response;
        customers.map((customer) => {
          customer.full_name = this.getName(customer);
          return customer;
        });
        return customers;
      })
    );
  }

  public addCustomer(customerModel: Partial<Customer>) {
    return this.http.post<Customer>(`customers`, customerModel);
  }

  public updateCustomer(customerModel: Customer) {
    if (customerModel['full_name']) {
      customerModel['full_name'] = undefined;
    }
    return this.http.put(`customers/` + customerModel.id, customerModel);
  }

  public delete(id: number) {
    return this.http.delete(`customers/${id}`);
  }

  public getCustomer(
    customerId: number,
    includes = [],
    appends = []
  ): Observable<Customer> {
    let qs = this.http.getWiths(includes);
    if (appends.length) {
      qs += `&${this.http.urlSerializeArray(appends, 'attributes')}`;
    }
    return this.http.get<Customer>('customers/' + customerId + qs).pipe(
      map((response) => {
        const customer = response;
        return customer;
      })
    );
  }

  getName(customer: Customer) {
    if (customer.business === 0) {
      let name = '';
      if (customer.first_name) {
        name = customer.first_name;
      }
      if (customer.last_name) {
        name += ' ' + customer.last_name;
      }
      return name.trim();
    }
    if (customer.business === 1) {
      return customer.business_name;
    }
  }

  search(searchTerm) {
    return this.http.get<Customer[]>('customers/search/' + searchTerm);
  }

  changedToBusiness(customer: Partial<Customer>) {
    if (
      !customer.business_name &&
      (customer.first_name || customer.last_name)
    ) {
      customer.business_name = this.getIndividualFullName(customer);
    }
  }

  changeToIndividual(customer) {
    if (!customer.first_name && !customer.last_name && customer.business_name) {
      customer.first_name = customer.business_name;
    }
  }

  mergeCustomers(fromId, toId) {
    return this.http.put('customers/merge', { fromId, toId });
  }

  private getIndividualFullName(customer) {
    let name = '';
    if (customer.first_name) {
      name = customer.first_name;
    }
    if (customer.last_name) {
      name += ' ' + customer.last_name;
    }
    return name.trim();
  }

  getSalesHistory(customerId: number) {
    return this.http.get<CustomerSalesHistoryItem[]>(
      `customers/${customerId}/sales`
    );
  }

  getBalances(id: number) {
    return this.http.get<{
      total: number;
      contract: number;
      invoice: number;
      sales: number;
      repairs: number;
    }>(`customers/${id}/balances`);
  }

  getPreviousHires(
    customerId: number,
    params: any = {}
  ): Observable<{
    data: CustomerPreviousHiresItem[];
    count: number;
    pagination: {
      perPage: number;
      page: number;
      sortBy: string;
      sortOrder: string;
    };
  }> {
    return this.http.get(`customers/${customerId}/previous-hires`, { params });
  }

  exportPreviousHiresToExcel(
    customerId: number,
    onlyActive: boolean = false
  ): Observable<Blob> {
    return this.http.get(`customers/${customerId}/previous-hires`, {
      params: { onlyActive },
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }
}
